import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useParticipantCountry } from "@/features/auth";

import { isTaxRequiredForCountry } from "../helpers/is-tax-required";

export const USTaxGuard = () => {
  const { countryCode } = useParticipantCountry();
  const navigate = useNavigate();

  useEffect(() => {
    // Allow every country whose tax requirement is an integration form (US and
    // its territory Puerto Rico); redirect everyone else away (NBP-1504).
    if (!isTaxRequiredForCountry(countryCode)) {
      navigate("/", { replace: true });
    }
  }, [countryCode, navigate]);

  return <Outlet />;
};
